import style from "./index.module.scss"
import model_fallback from "../../../assets/img/model_fallback.png"
import EyeIcon from "../../../assets/icons/EyeIcon"
import { useState } from "react"
import RcmpButton from '../../atoms/Button'
export default function ModalCard(props) {
  const { opmd_cimage, opmd_cname, opmd_nid, fnShowDetail, handleCreateBoard: fnCreateBoard } = props
  const [bShowOverlay, fnSetBShowOverlay] = useState(false)
  const [bIsLoading, fnSetBIsLoading] = useState(false)

  const handleCreateBoard = async () => {
    try {
      fnSetBIsLoading(true)
      await fnCreateBoard(opmd_nid)
    } finally {
      fnSetBIsLoading(false)
    }
  }

  return (
    <div className={style.model}>
      <div
        className={style.imageWrapper}
        onMouseOver={() => fnSetBShowOverlay(true)}
        onMouseLeave={() => fnSetBShowOverlay(false)}
      >
        {bShowOverlay && (
          <>
            <div className={style.overlayBg} />
            <button className={style.overlayBtn} onClick={fnShowDetail}>
              <EyeIcon fill="#FFF" />
              Visualizar
            </button>
          </>
        )}
   
          <img
            src={opmd_cimage || model_fallback}
            className={style.modelImage}
            alt="Imagem do Modelo"
          />
       
      </div>
      <p title={opmd_cname}>{opmd_cname}</p>
      <RcmpButton isLoading={bIsLoading} onClick={handleCreateBoard}>
        Usar Modelo 
      </RcmpButton>
    </div>
  )
}
